import { FC, memo } from 'react'

import {
    Container,
    ContentWrapper,
    HighlightedReviewerName,
    ReviewerSection,
    ReviewerImageWrapper,
    ReviewerInfo,
    ReviewerName,
    ReviewerDescription,
} from './styles'
import { ReviewContentTransport } from '../../../transports/region-landing-page-transport'
import ImageLoadingComponent from '../../app-components/image-loading-component'
import { useTranslation } from '../../../hooks/locale'
import { Title, TitleContainer } from '../common/styles'

interface ReviewContentSectionProps {
    reviewContentSection: ReviewContentTransport
}

const ReviewContentSection: FC<ReviewContentSectionProps> = ({ reviewContentSection }) => {
    const { t } = useTranslation()
    const { reviewerImage, reviewedBy, content } = reviewContentSection
    const imageUrl = reviewerImage?.formats?.medium?.url || reviewerImage?.url

    if (!reviewedBy || !content) {
        return null
    }

    return (
        <Container id="review-content">
            <ContentWrapper>
                <TitleContainer>
                    <Title>
                        {t('contentReviewedBy')} <HighlightedReviewerName>{reviewedBy}</HighlightedReviewerName>
                    </Title>
                </TitleContainer>

                <ReviewerSection>
                    {imageUrl && (
                        <ReviewerImageWrapper>
                            <ImageLoadingComponent
                                src={imageUrl}
                                alt={reviewedBy || t('contentReviewer')}
                                objectFit="cover"
                                borderRadius="50%"
                            />
                        </ReviewerImageWrapper>
                    )}
                    <ReviewerInfo>
                        <ReviewerName>{reviewedBy}</ReviewerName>
                        <ReviewerDescription>{content}</ReviewerDescription>
                    </ReviewerInfo>
                </ReviewerSection>
            </ContentWrapper>
        </Container>
    )
}

export default memo(ReviewContentSection)
